<template>
    <form-switch
        v-if="!hide"
        v-model="value"
        @change="onChange"
        :disabled="params.disabled || false"
    />
</template>

<script>
    import FormSwitch from '../form-switch/form-switch.vue';

    export default {
        components: {
            FormSwitch,
        },
        data() {
            return {
                value: false,
                hideIfPinned: false,
            };
        },
        computed: {
            hide() {
                return this.hideIfPinned && this.params.node.rowPinned
            }
        },
        created() {
            this.value = this.params.value;
            this.hideIfPinned = this.params.hideIfPinned
        },
        methods: {
            setNewValue(newValue) {
                if (typeof this.params.onChange === 'function') {
                    this.value = newValue;
                    if (this.params.onChange) {
                        this.params.onChange(this.params, newValue);
                    }
                }
            },
            onChange({ value }) {
                var newValue = value;
                this.value = !value;

                if (this.params.msgOn && this.params.msgOff) {
                    var message = value
                        ? this.params.msgOn
                        : this.params.msgOff;
                    this.$bvModal
                        .msgBoxConfirm(message, {
                            id: 'switch-cell-confirm-modal',
                            title: 'Please Confirm',
                        })
                        .then(confirmed => {
                            if (confirmed) {
                                this.setNewValue(newValue);
                            } else {
                                this.value = !newValue;
                            }
                        })
                        .catch(() => {
                            /* Reset the value in case of an error */
                            this.value = !newValue;
                        });
                } else {
                    this.setNewValue(newValue);
                }
            },
        },
        mounted() {
            this.$root.$on('bv::modal::shown', (event, modalId) => {
                if (modalId == 'switch-cell-confirm-modal') {
                    try {
                        document
                            .getElementById('vue-app-modal-container')
                            .appendChild(event.target.offsetParent);
                    } catch (err) {}
                }
            });
        },
    };
</script>
